import ManagementModal from "../../../components/ui/modals/ManagementModal";
import React, { useState } from "react";

export interface RoleOption {
  label: string;
  value: string;
  description?: string;
}

export interface RoleSelectionModalProps {
  options: RoleOption[];
  onContinue: (selectedOption: RoleOption) => void;
  onCancel: () => void;
  title?: string;
  subtitle?: string;
}

const RoleSelectionModal: React.FC<RoleSelectionModalProps> = ({
  options,
  onContinue,
  onCancel,
  title = "Select Role",
  subtitle,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const selectedOption = options.find(
    (option) => option.value === selectedValue,
  );

  const handleContinue = () => {
    if (!selectedOption) {
      return;
    }

    onContinue(selectedOption);
  };

  return (
    <ManagementModal
      title={title}
      subtitle={subtitle}
      subtitleClassName="
        text-[12px]
        font-normal
        leading-4
        text-[#737373]
        font-[Inter]
      "
      onSubmit={handleContinue}
      onCancel={onCancel}
      onClose={onCancel}
      submitLabel="Continue"
      cancelLabel="Cancel"
      submitEnabled={Boolean(selectedOption)}
      className="w-[661px]"
    >
      <div className="flex flex-col gap-2">
        <p className="text-[14px] font-normal leading-5 text-[#737373]">
          Role on this account
        </p>

        <div className="grid grid-cols-2 gap-3">
          {options.map((option) => {
            const isSelected = selectedValue === option.value;

            return (
              <button
                key={option.value}
                type="button"
                onClick={() => setSelectedValue(option.value)}
                className={[
                  `
                    flex
                    min-w-0
                    flex-1
                    items-center
                    gap-4
                    rounded-[8px]
                    border
                    p-2
                    text-left
                  `,
                  isSelected
                    ? "border-[#A2AFF9] bg-[#EBEEFE]"
                    : "border-[#E5E5E5] bg-white",
                ].join(" ")}
              >
                <span
                  className="
                    flex
                    h-4
                    w-4
                    shrink-0
                    items-center
                    justify-center
                    rounded-full
                    border
                    border-[#E5E5E5]
                    bg-white
                    shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]
                  "
                >
                  {isSelected && (
                    <span className="h-2 w-2 rounded-full bg-[#3551F3]" />
                  )}
                </span>

                <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                  <span className="truncate text-[14px] font-normal leading-5 text-[#0A0A0A]">
                    {option.label}
                  </span>

                  {option.description && (
                    <span className="truncate text-[12px] font-normal leading-4 text-[#737373]">
                      {option.description}
                    </span>
                  )}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </ManagementModal>
  );
};

export default RoleSelectionModal;